import { render, staticRenderFns } from "./TableConstructorButton.vue?vue&type=template&id=9bff9526&lang=pug"
import script from "./TableConstructorButton.vue?vue&type=script&lang=js"
export * from "./TableConstructorButton.vue?vue&type=script&lang=js"
import style0 from "./TableConstructorButton.vue?vue&type=style&index=0&id=9bff9526&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports